export const setToken = (value: string) => {
  localStorage.setItem("TOKEN", value);
};

export const getToken = (): string | null => localStorage.getItem("TOKEN");

export const removeToken = () => {
  localStorage.removeItem("TOKEN");
};

export function getBasicAuthHeaders(token?: string) {
  return {
    Authorization: `Basic ${token}`,
    "Content-Type": "application/json",
  };
}
